import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { Hero } from "./components/Hero";
import { CollectionIntro } from "./components/CollectionIntro";
import { BeforeAfter } from "./components/BeforeAfter";
import { PainPoints } from "./components/PainPoints";
import { Volumes } from "./components/Volumes";
import { Toolkit } from "./components/Toolkit";
import { Bonuses } from "./components/Bonuses";
import { Offer } from "./components/Offer";
import { Guarantee } from "./components/Guarantee";
import { Testimonials } from "./components/Testimonials";
import { AuthorLetter } from "./components/AuthorLetter";
import { Faq } from "./components/Faq";
import { FinalCta } from "./components/FinalCta";
import { FloatingCta } from "./components/FloatingCta";
import { PurchasePopup } from "./components/PurchasePopup";
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-canvas" data-id="element-0" data-mp="28s2z1ddy01vz">
      <MetaPixel data-id="element-1" data-mp="23ut9lxqjzq85" />
      <Hero data-id="element-2" data-mp="23t8eo70bu59r" />
      <main data-id="element-3" data-mp="3ijxnsm94vshs">
        <CollectionIntro data-id="element-4" data-mp="3ik7jmqgv0tve" />
        <BeforeAfter data-id="element-5" data-mp="3iiwg8rrbto4t" />
        <PainPoints data-id="element-6" data-mp="3ijpbavgxap74" />
        <Volumes data-id="element-7" data-mp="3ii4ro0w5cqo1" />
        <Toolkit data-id="element-8" data-mp="3mlaxx8j9ehui" />
        <Bonuses data-id="element-9" data-mp="3mkrbpfmkt7ao" />
        <Offer data-id="element-10" data-mp="3mk852v2dm5by" />
        <Guarantee data-id="element-11" data-mp="3mjq27fl7ksv2" />
        <Testimonials data-id="element-12" data-mp="3mj6jvxrnc2gi" />
        <AuthorLetter data-id="element-13" data-mp="3rcj2nr9n9f1c" />
        <Faq data-id="element-14" data-mp="3rdas0kcnegj6" />
        <FinalCta data-id="element-15" data-mp="3rcsxpt9jqcdw" />
      </main>
      <FloatingCta data-id="element-16" data-mp="3relu8fqg3g86" />
      <PurchasePopup data-id="element-17" data-mp="5orh0l86u6j" />
    </div>;
}